/* ============================================
   CASECRAFT STUDIO — THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ---- Mobile Menu ----
  const mobileBtn = document.querySelector('.mobile-menu-btn');
  const nav = document.querySelector('.header-nav');
  if (mobileBtn && nav) {
    mobileBtn.addEventListener('click', () => {
      nav.classList.toggle('mobile-open');
    });
  }

  // ---- Animate on scroll ----
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.product-card, .category-card, .step-card, .review-card').forEach(el => {
    observer.observe(el);
  });

  // ---- Product image thumbnails ----
  document.querySelectorAll('.thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.querySelector('img')?.src;
      const mainImg = document.querySelector('.main-image img');
      if (src && mainImg) {
        mainImg.src = src;
      }
      document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  

  // ---- Color swatches ----
  document.querySelectorAll('.color-swatch').forEach(swatch => {
    swatch.addEventListener('click', () => {
      const group = swatch.closest('.color-swatches');
      group.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
    });
  });

  // ---- Quantity controls ----
  document.querySelectorAll('.qty-control').forEach(ctrl => {
    const minusBtn = ctrl.querySelector('[data-action="minus"]');
    const plusBtn = ctrl.querySelector('[data-action="plus"]');
    const valueEl = ctrl.querySelector('.qty-value');

    if (minusBtn && plusBtn && valueEl) {
      minusBtn.addEventListener('click', () => {
        const current = parseInt(valueEl.textContent) || 1;
        if (current > 1) valueEl.textContent = current - 1;
      });

      plusBtn.addEventListener('click', () => {
        const current = parseInt(valueEl.textContent) || 1;
        valueEl.textContent = current + 1;
      });
    }
  });

  // ---- Filter tags ----
  document.querySelectorAll('.filter-tag').forEach(tag => {
    tag.addEventListener('click', () => {
      document.querySelectorAll('.filter-tag').forEach(t => t.classList.remove('active'));
      tag.classList.add('active');
    });
  });

  // ---- Add to cart (AJAX) ----
  document.querySelectorAll('.btn-add-cart, .btn-atc').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const idInput = document.getElementById('variant-id-input');
      const variantId = idInput ? idInput.value : null;
      if (!variantId) return;

      const self = this;
      const original = self.textContent;
      self.disabled = true;
      self.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(r => r.json())
      .then(data => {
        if (data.status === 422 || data.description) {
          self.textContent = data.description || 'Error';
          self.style.background = '#ef4444';
          self.style.color = '#fff';
        } else {
          self.textContent = '✓ Added!';
          self.style.background = '#22c55e';
          self.style.color = '#fff';
          return fetch('/cart.js').then(r => r.json()).then(cart => {
            const cartCount = document.querySelector('.cart-count');
            if (cartCount) cartCount.textContent = cart.item_count;
          });
        }
      })
      .catch(() => {
        self.textContent = 'Error — try again';
        self.style.background = '#ef4444';
        self.style.color = '#fff';
      })
      .finally(() => {
        setTimeout(() => {
          self.textContent = original;
          self.style.background = '';
          self.style.color = '';
          self.disabled = false;
        }, 1800);
      });
    });
  });

  // ---- Newsletter form ----
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = newsletterForm.querySelector('.newsletter-input');
      const btn = newsletterForm.querySelector('.newsletter-submit');
      if (input && btn) {
        btn.textContent = '✓ Subscribed!';
        btn.style.background = '#22c55e';
        input.value = '';
        setTimeout(() => {
          btn.textContent = 'Subscribe';
          btn.style.background = '';
        }, 3000);
      }
    });
  }

  // ---- Header scroll effect ----
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 80) {
        header.style.borderBottomColor = 'rgba(232,255,71,0.1)';
      } else {
        header.style.borderBottomColor = '';
      }
    });
  }

  // ---- Category slideshows ----
  document.querySelectorAll('[data-slideshow]').forEach(card => {
    const slides = card.querySelectorAll('.cat-slide-img');
    const dots   = card.querySelectorAll('.cat-dot');
    if (slides.length <= 1) return;
    let current = 0;
    function advance() {
      slides[current].classList.remove('active');
      dots[current] && dots[current].classList.remove('active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('active');
      dots[current] && dots[current].classList.add('active');
    }
    let timer = setInterval(advance, 2500);
    card.addEventListener('mouseenter', () => clearInterval(timer));
    card.addEventListener('mouseleave', () => { timer = setInterval(advance, 2500); });
  });
});

// Carousel scroll
function scrollCarousel(id, dir) {
  const track = document.getElementById(id);
  if (!track) return;
  const card = track.querySelector('.product-card');
  const cardW = card ? card.offsetWidth + 12 : 280;
  track.scrollBy({ left: dir * cardW * 2, behavior: 'smooth' });
}

  // ---- Variant dropdowns with brand-filtered model list ----
  (function () {
    if (typeof productVariants === 'undefined') return;

    const brandSelect = document.getElementById('Option-1');
    const modelSelect = document.getElementById('Option-2');
    const idInput     = document.getElementById('variant-id-input');
    const addBtn      = document.querySelector('.btn-atc');
    const mainImg     = document.getElementById('main-product-img');
    if (!brandSelect || !modelSelect) return;

    // Build brand -> ordered unique model list from variant data
    const brandModels = {};
    productVariants.forEach(v => {
      const brand = v.options[0], model = v.options[1];
      if (!brandModels[brand]) brandModels[brand] = [];
      if (!brandModels[brand].includes(model)) brandModels[brand].push(model);
    });

    function filterModels() {
      const brand  = brandSelect.value;
      const models = brandModels[brand] || [];
      modelSelect.innerHTML = models
        .map(m => '<option value="' + m + '">' + m + '</option>')
        .join('');
    }

    function findVariant() {
      const brand = brandSelect.value, model = modelSelect.value;
      return productVariants.find(v => v.options[0] === brand && v.options[1] === model);
    }

    function updatePage() {
      const variant = findVariant();
      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      if (addBtn) {
        addBtn.disabled    = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src;
      }
    }

    brandSelect.addEventListener('change', () => {
      filterModels();
      updatePage();
    });
    modelSelect.addEventListener('change', updatePage);

    filterModels();
    updatePage();
  })();